import store from "../store";
import {
  IBulkAssignAssetsPayload,
  ICreateAssetPayload,
  ICreateAssetTypePayload,
  ICreateAssetsPayload,
  allAssets,
  allCheckAssets,
  assetTypes,
  bulkAssignAssets,
  bulkCheckAssetsByIds,
  bulkDeleteAssets as bulkDeleteService,
  bulkUnassignAssets,
  createAsset,
  createAssets,
  createType,
  selfAssets,
} from "./../../services/assetsService";
import { bulkDeleteTypes as bulkDeleteTypesService } from "./../../services/assetsService";
import {
  addAsset,
  addType,
  bulkCheckAssets,
  bulkDeleteAssets,
  bulkDeleteTypes,
  setAssetTypes,
  setAssets,
} from "./reducer";

const { dispatch } = store;

// User Actions
export const dispatchSelfAssetsAction = () => selfAssets().then(async (payload) => dispatch(setAssets(payload)));

// Admin Actions
export const dispatchAllAssetsAction = () => allAssets().then(async (payload) => dispatch(setAssets(payload)));

export const dispatchAllCheckAssetsAction = () =>
  allCheckAssets().then(async (payload) => dispatch(setAssets(payload)));

export const dispatchCheckAssetsAction = (ids: string[], checkDate: string) =>
  bulkCheckAssetsByIds(ids, checkDate).then(async () => dispatch(bulkCheckAssets({ ids, checkDate })));

export const dispatchBulkDeleteAssetsAction = (ids: string[]) =>
  bulkDeleteService(ids).then(async () => dispatch(bulkDeleteAssets(ids)));

export const dispatchAssetTypesAction = () => assetTypes().then(async (payload) => dispatch(setAssetTypes(payload)));

export const dispatchCreateAssetAction = (payload: ICreateAssetPayload) =>
  createAsset(payload).then(async (asset) => dispatch(addAsset(asset)));

export const dispatchCreateAssetsAction = (payload: ICreateAssetsPayload) => createAssets(payload);

export const dispatchCreateTypeAction = (payload: ICreateAssetTypePayload) =>
  createType(payload).then(async (type) => dispatch(addType(type)));

export const dispatchBulkDeleteTypesAction = (ids: string[]) =>
  bulkDeleteTypesService(ids).then(async () => dispatch(bulkDeleteTypes(ids)));

export const dispatchBulkAssignAssetsAction = (payload: IBulkAssignAssetsPayload) => bulkAssignAssets(payload);

export const dispatchBulkUnassignAssetsAction = (ids: string[]) => bulkUnassignAssets(ids);
